import { TPeriod } from '../../../types/developerValuation/developerValuationFilters';

const postfixes: Record<TPeriod, string> = {
  allTime: 'все время',
  year: 'год',
  halfYear: 'полгода',
};

export const getPriceDiffTitle = (period: TPeriod = 'allTime') => `Изменение цены м² за ${postfixes[period]}`;
